<span class="text-copy-wrapper">
  <ng-content></ng-content>
  @if (!disableClipboardCopy() && text()) {
    <button type="button" class="btn btn-sm btn-light ms-2 btn-copy" (click)="copyToClipboard($event, text())">
      <i class="far fa-copy"></i>
    </button>
  }
</span>
